var _a;
/**
 * @hidden
 */


export var cancel = 'upload.cancel';
/**
 * @hidden
 */

export var clearSelectedFiles = 'upload.clearSelectedFiles';
/**
 * @hidden
 */

export var dropFilesHere = 'upload.dropFilesHere';
/**
 * @hidden
 */

export var headerStatusUploaded = 'upload.headerStatusUploaded';
/**
 * @hidden
 */

export var headerStatusUploading = 'upload.headerStatusUploading';
/**
 * @hidden
 */

export var invalidFileExtension = 'upload.invalidFileExtension';
/**
 * @hidden
 */

export var invalidFiles = 'upload.invalidFiles';
/**
 * @hidden
 */

export var invalidMaxFileSize = 'upload.invalidMaxFileSize';
/**
 * @hidden
 */

export var invalidMinFileSize = 'upload.invalidMinFileSize';
/**
 * @hidden
 */

export var remove = 'upload.remove';
/**
 * @hidden
 */

export var retry = 'upload.retry';
/**
 * @hidden
 */

export var select = 'upload.select';
/**
 * @hidden
 */

export var uploadSelectedFiles = 'upload.uploadSelectedFiles';
/**
 * @hidden
 */

export var total = 'upload.total';
/**
 * @hidden
 */

export var files = 'upload.files';
/**
 * @hidden
 */

export var messages = (_a = {}, _a[cancel] = 'Cancel', _a[clearSelectedFiles] = 'Clear', _a[dropFilesHere] = 'Drop files here to upload', _a[headerStatusUploaded] = 'Done', _a[headerStatusUploading] = 'Uploading...', _a[invalidFileExtension] = 'File type not allowed.', _a[invalidFiles] = 'Invalid file(s). Please check file upload requirements.', _a[invalidMaxFileSize] = 'File size too large.', _a[invalidMinFileSize] = 'File size too small.', _a[remove] = 'Remove', _a[retry] = 'Retry', _a[select] = 'Select files...', _a[uploadSelectedFiles] = 'Upload', _a[total] = 'Total', _a[files] = 'files', _a);